import { useContext, useEffect, useRef, useState } from 'react';

import styles from './NewDatePickerComponent.module.css'

import { GlobalContext } from '../../../contexts/globalContext';
import { AddConferenceContext } from '../../../contexts/addConferenceContext';

import { generateDateList, compareDate } from '../../../utils/UtilitaryFunctions';

import highlight from '../../../graphics/conference add/highlight-data.svg'


const NewDatePickerComponent = ({ selectedDate, setSelectedDate, changedYear, setChangedYear, changedMonth, setChangedMonth }) => {

    const { appWidth, setAlertMessage } = useContext(GlobalContext)
    const { calendarRef } = useContext(AddConferenceContext)

    const alreadyScrolledRef = useRef(false)
    const currentDate = new Date();
    const currentDateScrollRef = useRef(new Date(selectedDate))

    const [timesOffsetWasMoved, setTimesOffsetWasMoved] = useState(1)

    const dayWidth = 148.8
    const dayOffsetStart = parseInt(appWidth / dayWidth / 2) // 148.8 este latimea unei casute de data
    const margin = appWidth / 2 % dayWidth - dayWidth / 2
    const dayOffsetEnd = 2 * dayOffsetStart

    const [dateList, setDateList] = useState(generateDateList(selectedDate, dayOffsetStart, dayOffsetEnd))


    useEffect(() => {
        calendarRef.current.style.marginLeft = `${margin}px`
    }, [])

    useEffect(() => {
        if (changedYear || changedMonth) {
            // aici trebuie lucrat putin la if
            if (selectedDate > currentDate) {
                let newCenter = new Date(selectedDate)
                newCenter.setDate(selectedDate.getDate() - dayOffsetEnd / 2)

                currentDateScrollRef.current = newCenter
                setDateList(generateDateList(newCenter, dayOffsetStart, dayOffsetEnd * 2))
                setTimesOffsetWasMoved(2)

                calendarRef.current.scrollLeft = Math.floor(dayOffsetEnd / 2 * dayWidth)
            } else {
                currentDateScrollRef.current = selectedDate
                setDateList(generateDateList(selectedDate, dayOffsetStart, dayOffsetEnd))
                setTimesOffsetWasMoved(1)

                calendarRef.current.scrollLeft = 0
            }
            setChangedYear(false)
            setChangedMonth(false)

        } else {

            if (selectedDate > currentDate && selectedDate.getDate() === currentDateScrollRef.current.getDate()) {
                let newCenter = new Date(selectedDate)
                newCenter.setDate(selectedDate.getDate() - dayOffsetEnd / 2)

                if (newCenter > currentDate) {
                    currentDateScrollRef.current = newCenter
                    setDateList(generateDateList(newCenter, dayOffsetStart, dayOffsetEnd * (timesOffsetWasMoved + 1)))
                    setTimesOffsetWasMoved(timesOffsetWasMoved + 1)

                    calendarRef.current.scrollLeft = Math.floor(dayOffsetEnd / 2 * dayWidth)
                } else {
                    currentDateScrollRef.current = currentDate
                    setDateList(generateDateList(currentDate, dayOffsetStart, dayOffsetEnd * (timesOffsetWasMoved + 1)))
                    setTimesOffsetWasMoved(timesOffsetWasMoved + 1)

                    const currentDateStartOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
                    const selectedDateStartOfDay = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate())

                    const diffInMilliseconds = Math.abs(selectedDateStartOfDay.getTime() - currentDateStartOfDay.getTime())

                    calendarRef.current.scrollLeft = Math.floor(Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24)) * dayWidth)
                }
                alreadyScrolledRef.current = true

            }

            const dateMaxForScroll = new Date(currentDateScrollRef.current);
            dateMaxForScroll.setDate(currentDateScrollRef.current.getDate() + (timesOffsetWasMoved - 1) * dayOffsetEnd + 2)

            if (dateMaxForScroll < selectedDate && !changedYear) {
                setDateList(generateDateList(currentDateScrollRef.current, dayOffsetStart, dayOffsetEnd * (timesOffsetWasMoved + 1)))
                setTimesOffsetWasMoved(timesOffsetWasMoved + 1)
            }
        }

    }, [selectedDate])


    const handleScrollDay = () => {

        if (calendarRef.current && !alreadyScrolledRef.current) {

            const calendarDays = calendarRef.current.children;

            for (let i = 0; i < calendarDays.length; i++) {
                const rect = calendarDays[i].getBoundingClientRect();

                if (rect.left >= -15) {
                    const date = new Date(currentDateScrollRef.current);
                    date.setDate(currentDateScrollRef.current.getDate() + i);

                    const d1 = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                    const d2 = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());

                    if (d1.getTime() !== d2.getTime()) {
                        setSelectedDate(date)
                    }

                    break;
                }
            }
        }
        alreadyScrolledRef.current = false

    };

    function handleClickDay(day) {

        let clickedDate = new Date(day.date)

        let dateCurrentScroll = new Date(currentDateScrollRef.current)

        dateCurrentScroll.setHours(currentDate.getHours(), currentDate.getMinutes() + 1, 0, 0);
        clickedDate.setHours(currentDate.getHours(), currentDate.getMinutes() + 1, 0, 0);

        let date = new Date(currentDate)
        if (dateCurrentScroll < currentDate) {
            date = dateCurrentScroll
        }

        if (clickedDate >= date) {
            setSelectedDate(clickedDate)
            positionScroll(clickedDate)
        } else {
            setAlertMessage({ type: "ERROR", message: `The selected date is in the past.` });
        }

    }

    function positionScroll(date) {
        const selectedDateStartOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const currentDateStartOfDay = new Date(currentDateScrollRef.current.getFullYear(), currentDateScrollRef.current.getMonth(), currentDateScrollRef.current.getDate())

        const diffInMilliseconds = selectedDateStartOfDay.getTime() - currentDateStartOfDay.getTime()

        if (diffInMilliseconds < 0) {
            currentDateScrollRef.current = selectedDateStartOfDay
            setDateList(generateDateList(selectedDateStartOfDay, dayOffsetStart, dayOffsetEnd))
        }

        calendarRef.current.scrollLeft = Math.floor(Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24)) * dayWidth)

        alreadyScrolledRef.current = true

    }


    return (
        <div style={{ position: "relative" }}>
            <div className={styles.selectedCalendarDay} style={{ height: 265, overflow: "hidden" }}>
                <img src={highlight} className={styles.selectedCalendarDay} style={{ top: 40 }} />
            </div>

            {selectedDate !== undefined && <div className={styles.calendar} ref={calendarRef} onScroll={handleScrollDay} onTouchStart={() => handleScrollDay()}>
                {dateList.map((item, index) => (
                    <div key={index} className={styles.calendarDay} onClick={() => handleClickDay(item)} style={{ color: compareDate(selectedDate, item.date) ? "#050020" : "" }}>
                        <div className={styles.calendarMonth}></div>
                        <div className={styles.calendarDayNumber}>{item.dayNumber}</div>
                        <div className={styles.calendarDayOfWeek}>{item.dayOfWeek}</div>
                    </div>
                ))}
            </div>}
        </div>
    );

}

export default NewDatePickerComponent;